import React, {useState} from "react";
import {useNavigate} from "react-router";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {ModalFooter} from "../Components/BookingModalShell.jsx";
import {getToken} from "@/utils/authToken";
import {bookingIdentityStep} from "@/utils/identityGate";
import {Loader} from "@/customComponents/uiComponents/Loader.jsx";

export function MainPolicies({setStep, closeModal}) {
    const navigate = useNavigate();
    const isAuthenticated = !!getToken();
    const [checking, setChecking] = useState(false);

    // Same gate as orderDetails Continue: an account with no phone goes to
    // completeProfile before payment.
    const handleAgree = async () => {
        if (!isAuthenticated) {
            navigate('/signin');
            return;
        }
        setChecking(true);
        const gateStep = await bookingIdentityStep('paymentCards');
        setChecking(false);
        setStep(gateStep || 'paymentCards');
    };
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep="orderDetails" showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <div className="hopn-instruction-layout modalPages-spacing">
                <h3>Important: Select the Right Luggage & Extras 🚨 <span>To ensure a smooth pickup, please select the correct luggage size, car seats, and oversized items when booking.</span></h3>
                <span className="important-note">⚠ If your luggage exceeds the selected capacity, kindly modify your booking in advance.</span>
                <span className="important-note">❌ Failure to update your booking may result in cancellation at pickup. If the driver cannot accommodate excess luggage, they have the right to cancel the ride, and this will be considered a passenger no-show, leading to a full fare charge with no refund.</span>
                <p>By proceeding, you confirm that you understand and agree to these terms.</p>
            </div>
            <ModalFooter>
                <button className="hopn-add-passenger-button no-icon" disabled={checking} onClick={handleAgree}>
                    {checking ? <Loader color="#fff"/> : '✅ I Agree & Continue'}
                </button>
            </ModalFooter>
        </>
    );
}
export default MainPolicies;
